// extracted by mini-css-extract-plugin
export default {"wrapper":"TransactionsTable_wrapper_CMuCo"};